import { IsNumber, IsString } from 'class-validator';

export class DealTypeList {
    @IsNumber()
    id!: number;
    @IsString()
    name!: string;
}
